

<div align="center">
    <qrcode [level]="1" [(qrvalue)]="data.secret" size=400></qrcode>
</div>
